<template>
  <div class="scope-select">
    <el-input-number
      :disabled="props.disabled"
      class="left"
      clearable
      placeholder="0"
      @input="searchChange"
      v-model="state.data.startingQty"
    />
    <span class="interval"> ~ </span>
    <el-input-number
      :disabled="props.disabled"
      class="right"
      clearable
      placeholder="0"
      @input="searchChange"
      v-model="state.data.endQty"
    />
  </div>
</template>

<script lang="ts">
import { CaretBottom, CaretTop, DataLine } from "@element-plus/icons-vue";
import isArray from "lodash-es/isArray";
import { defineComponent, onMounted, onBeforeMount, reactive, watch } from "vue";
import type { ComponentPublicInstance, ExtractPropTypes, PropType, SetupContext, StyleValue, VNode } from "vue";
import $, { post } from "jquery";
import { buildProps } from "../../utils/props";

import { cloneDeep, times } from "lodash-es";
import moment from "moment";
import isEqual from "lodash-es/isEqual";
const NumberRangeProps = buildProps({
  modelValue: {
    type: Object,
    default: () => ({}),
  },
  setValue: {
    type: Object,
    default: () => ({
      startingQty: "startingQty",
      endQty: "endQty",
    }),
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  // disabled: {
  //   type: [string,un],
  //   default: false,
  // },
});
type NumberRangePropsType = ExtractPropTypes<typeof NumberRangeProps>;
export default defineComponent({
  // emits: ["update:modelValue"],
  name: "quantityRange",
  props: NumberRangeProps,
  setup(props: NumberRangePropsType, ctx: SetupContext<any>) {
    var state: any = reactive({
      data: {
        startingQty: null,
        endQty: null,
      },
      comparativeData: {},
    });
    // 搜索值的改变
    function searchChange() {
      state.comparativeData = {
        [props.setValue.startingQty]: state.data.startingQty,
        [props.setValue.endQty]: state.data.endQty,
      };
      ctx.emit("update:modelValue", { ...state.comparativeData });
    }
    onBeforeMount(() => {
      state.data = {
        startingQty: null,
        endQty: null,
      };
      searchChange();
    });
    watch(
      () => props.modelValue,
      (v: any) => {
        if (!isEqual(v, state.comparativeData)) {
          let { startingQty, endQty } = props.setValue;
          let qty1 = v[startingQty];
          let qty2 = v[endQty];
          state.data = {
            startingQty: qty1,
            endQty: qty2,
          };
          state.comparativeData = {};
          state.comparativeData[startingQty] = qty1;
          state.comparativeData[endQty] = qty2;
        }
      },
      { deep: true }
    );
    return {
      searchChange,
      props,
      state,
    };
  },
});
</script>

<style lang="scss" scoped>
:deep( .el-input-number .el-input__wrapper ) {
  padding-left: 0px;
  padding-right: 0px;
}
:deep( .el-input-number--mini .el-input__inner ) {
  padding: 0;
}
:deep( .el-input-number__increase ) {
  display: none;
}
:deep( .el-input-number__decrease ) {
  display: none;
}
.scope-select {
  max-width: 100%;
  display: flex;
  flex-wrap: nowrap;
  .left {
    flex: 1 !important;
  }
  .interval {
    display: inline-block;
    padding: 0 6px;
  }
  .right {
    flex: 1 !important;
  }
}
</style>
